import * as t from "io-ts";

const VenueAddress = t.union([
  t.null,
  t.type({
    address_1: t.union([t.null, t.string]),
    address_2: t.union([t.null, t.string]),
    city: t.union([t.null, t.string]),
    region: t.union([t.null, t.string]),
    postal_code: t.union([t.null, t.string]),
    country: t.union([t.null, t.string]),
    latitude: t.union([t.null, t.string]),
    longitude: t.union([t.null, t.string]),
    localized_address_display: t.union([t.null, t.string, t.undefined]),
  }),
]);

export const Venue = t.type({
  id: t.string,
  name: t.string,
  address: VenueAddress,
  // resource_uri: t.string,
  // latitude: t.string,
  // longitude: t.string,
  // capacity: t.union([t.null, t.number]),
  // age_restriction: t.union([t.null, t.string]),
});

export type Venue = t.TypeOf<typeof Venue>;
